<template>
    <div v-if="mostrar" class="modal-mask" @click.self="$emit('fechar', false)">
        <div class="jm" style="height: max-content; width: 38rem; padding: 1rem 2rem; border-radius: 5px;" @click.stop>
            <div>
                <h3>Concluir {{ protocolo?.tipo_nome }}?</h3>
            </div>
            <hr>
            <div style="margin-top: 1rem">
                <!-- Ao concluir a última tarefa, -->
                 O <strong>{{ protocolo?.codigo }}</strong>
                passará para o status "Concluído" e <strong>não poderá ser editado novamente</strong>. Deseja prosseguir?
            </div>
            <div class="submit direita">
                <button class="acao-secundaria" @click="$emit('fechar', false)">Cancelar</button>
                <button class="button" @click="$emit('confirmar', true)">Sim, concluir</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalConfirmarConcluirProtocolo",
    props: {
        mostrar: { type: Boolean, default: false },
        protocolo: { type: Object, default: () => ({}) },
    },
    emits: ["fechar", "confirmar"],
};
</script>
